export default function ({ ...props }) {
    return (
        <svg {...props} xmlns="http://www.w3.org/2000/svg" width="28" height="28" viewBox="0 0 28 28" fill="none">
            <g opacity="0.5">
                <circle cx="14" cy="14" r="13" stroke="white" strokeWidth="2" />
                <rect x="9" y="9" width="3" height="10" rx="1.5" fill="white" />
                <rect x="16" y="9" width="3" height="10" rx="1.5" fill="white" />
            </g>
        </svg>
    );
}
